import BtnOptions from './ReportOptions/BtnOptions';
import Report1Options from './ReportOptions/Report1Options';
import Report2Options from './ReportOptions/Report2Options';
import Report3Options from './ReportOptions/Report3Options';
import Report6Options from './ReportOptions/Report6Options';
import Report8Options from './ReportOptions/Report8Options';
import Report10Options from './ReportOptions/Report10Options';
import Report13Options from './ReportOptions/Report13Options';
import Report14Options from './ReportOptions/Report14Options';
import Report15Options from './ReportOptions/Report15Options';
import Report16Options from './ReportOptions/Report16Options';
import Report17Options from './ReportOptions/Report17Options';
import Report19Options from './ReportOptions/Report19Options';
import Report20Options from './ReportOptions/Report20Options';
import Report23Options from './ReportOptions/Report23Options';
import Report24Options from './ReportOptions/Report24Options';
import Report25Options from './ReportOptions/Report25Options';
import Report27Options from './ReportOptions/Report27Options';
import Report28Options from './ReportOptions/Report28Options';
import Report30Options from './ReportOptions/Report30Options';
import Report32Options from './ReportOptions/Report32Options';
import Report33Options from './ReportOptions/Report33Options';
import Report36Options from './ReportOptions/Report36Options';
import Report38Options from './ReportOptions/Report38Options';
import Report40Options from './ReportOptions/Report40Options';
import Report42Options from './ReportOptions/Report42Options';
import Report44Options from './ReportOptions/Report44Options';
import Report45Options from './ReportOptions/Report45Options';
import Report47Options from './ReportOptions/Report47Options';
import Report49Options from './ReportOptions/Report49Options';
import Report50Options from './ReportOptions/Report50Options';
import Report51Options from './ReportOptions/Report51Options';
import Report52Options from './ReportOptions/Report52Options';
import Report53Options from './ReportOptions/Report53Options';
import Report54Options from './ReportOptions/Report54Options';
import Report57Options from './ReportOptions/Report57Options';
import Report56Options from './ReportOptions/Report56Options';
import Report59Options from './ReportOptions/Report59Options';
import Report60Options from './ReportOptions/Report60Options';

const ReportOptionsSwitch = (props) => {
  const {
    reportType,
    selectedReport,
    handleOnSubmit,
    handleOnShowSaveProfileModal,
    values,
    errors,
    handleOnSetFieldValue,
  } = props;
  switch (reportType) {
    case 1:
      return (
        <Report1Options
          handleOnSetFieldValue={handleOnSetFieldValue}
          values={values}
          handleOnSubmit={handleOnSubmit}
          handleOnSave={handleOnShowSaveProfileModal}
        />
      );
    case 2:
      return (
        <Report2Options
          handleOnSetFieldValue={handleOnSetFieldValue}
          values={values}
          handleOnSubmit={handleOnSubmit}
          handleOnSave={handleOnShowSaveProfileModal}
        />
      );
    case 3:
      return (
        <Report3Options
          handleOnSetFieldValue={handleOnSetFieldValue}
          values={values}
          handleOnSubmit={handleOnSubmit}
          handleOnSave={handleOnShowSaveProfileModal}
          selectedReport={selectedReport}
        />
      );
    case 6:
      return (
        <Report6Options
          handleOnSetFieldValue={handleOnSetFieldValue}
          values={values}
          handleOnSubmit={handleOnSubmit}
          handleOnSave={handleOnShowSaveProfileModal}
        />
      );
    case 8:
      return (
        <Report8Options
          handleOnSetFieldValue={handleOnSetFieldValue}
          values={values}
          handleOnSubmit={handleOnSubmit}
          handleOnSave={handleOnShowSaveProfileModal}
        />
      );
    case 10:
      return (
        <Report10Options
          handleOnSetFieldValue={handleOnSetFieldValue}
          values={values}
          handleOnSubmit={handleOnSubmit}
          handleOnSave={handleOnShowSaveProfileModal}
        />
      );
    case 13:
      return (
        <Report13Options
          handleOnSetFieldValue={handleOnSetFieldValue}
          values={values}
          handleOnSubmit={handleOnSubmit}
          handleOnSav={handleOnShowSaveProfileModal}
          selectedReport={selectedReport}
        />
      );
    case 14:
      return (
        <Report14Options
          handleOnSetFieldValue={handleOnSetFieldValue}
          values={values}
          handleOnSubmit={handleOnSubmit}
          handleOnSave={handleOnShowSaveProfileModal}
        />
      );
    case 15:
      return (
        <Report15Options
          handleOnSetFieldValue={handleOnSetFieldValue}
          values={values}
          handleOnSubmit={handleOnSubmit}
          handleOnSave={handleOnShowSaveProfileModal}
        />
      );
    case 16:
      return (
        <Report16Options
          handleOnSetFieldValue={handleOnSetFieldValue}
          values={values}
          handleOnSubmit={handleOnSubmit}
          handleOnSave={handleOnShowSaveProfileModal}
        />
      );
    case 17:
      return (
        <Report17Options
          handleOnSetFieldValue={handleOnSetFieldValue}
          values={values}
          handleOnSubmit={handleOnSubmit}
          handleOnSave={handleOnShowSaveProfileModal}
        />
      );
    case 19:
      return (
        <Report19Options
          handleOnSetFieldValue={handleOnSetFieldValue}
          values={values}
          handleOnSubmit={handleOnSubmit}
          handleOnSave={handleOnShowSaveProfileModal}
          selectedReport={selectedReport}
        />
      );
    case 20:
      return (
        <Report20Options
          handleOnSetFieldValue={handleOnSetFieldValue}
          values={values}
          handleOnSubmit={handleOnSubmit}
          handleOnSave={handleOnShowSaveProfileModal}
          selectedReport={selectedReport}
        />
      );
    case 23:
      return (
        <Report23Options
          handleOnSetFieldValue={handleOnSetFieldValue}
          values={values}
          handleOnSubmit={handleOnSubmit}
          handleOnSave={handleOnShowSaveProfileModal}
          selectedReport={selectedReport}
        />
      );
    case 24:
      return (
        <Report24Options
          handleOnSetFieldValue={handleOnSetFieldValue}
          values={values}
          handleOnSubmit={handleOnSubmit}
          handleOnSav={handleOnShowSaveProfileModal}
          selectedReport={selectedReport}
        />
      );
    case 25:
      return (
        <Report25Options
          handleOnSetFieldValue={handleOnSetFieldValue}
          values={values}
          handleOnSubmit={handleOnSubmit}
          handleOnSave={handleOnShowSaveProfileModal}
        />
      );
    case 27:
      return (
        <Report27Options
          handleOnSetFieldValue={handleOnSetFieldValue}
          values={values}
          handleOnSubmit={handleOnSubmit}
          handleOnSav={handleOnShowSaveProfileModal}
          selectedReport={selectedReport}
        />
      );
    case 28:
      return (
        <Report28Options
          handleOnSetFieldValue={handleOnSetFieldValue}
          values={values}
          handleOnSubmit={handleOnSubmit}
          handleOnSav={handleOnShowSaveProfileModal}
          selectedReport={selectedReport}
        />
      );
    // case 30:
    //   return (
    //     <Report30Options
    //       handleOnSetFieldValue={handleOnSetFieldValue}
    //       values={values}
    //       handleOnSubmit={handleOnSubmit}
    //       handleOnSav={handleOnShowSaveProfileModal}
    //       selectedReport={selectedReport}
    //     />
    //   );
    case 32:
      return (
        <Report32Options
          handleOnSetFieldValue={handleOnSetFieldValue}
          values={values}
          handleOnSubmit={handleOnSubmit}
          handleOnSave={handleOnShowSaveProfileModal}
          selectedReport={selectedReport}
        />
      );
    case 33:
      return (
        <Report33Options
          handleOnSetFieldValue={handleOnSetFieldValue}
          values={values}
          handleOnSubmit={handleOnSubmit}
          handleOnSave={handleOnShowSaveProfileModal}
        />
      );
    case 36:
      return (
        <Report36Options
          handleOnSetFieldValue={handleOnSetFieldValue}
          values={values}
          handleOnSubmit={handleOnSubmit}
          handleOnSave={handleOnShowSaveProfileModal}
        />
      );
    case 38:
      return (
        <Report38Options
          handleOnSetFieldValue={handleOnSetFieldValue}
          values={values}
          handleOnSubmit={handleOnSubmit}
          handleOnSave={handleOnShowSaveProfileModal}
          selectedReport={selectedReport}
        />
      );
    case 40:
      return (
        <Report40Options
          handleOnSetFieldValue={handleOnSetFieldValue}
          values={values}
          handleOnSubmit={handleOnSubmit}
          handleOnSav={handleOnShowSaveProfileModal}
          selectedReport={selectedReport}
        />
      );
    case 42:
      return (
        <Report42Options
          handleOnSetFieldValue={handleOnSetFieldValue}
          values={values}
          handleOnSubmit={handleOnSubmit}
          handleOnSave={handleOnShowSaveProfileModal}
        />
      );
    case 44:
      return (
        <Report44Options
          handleOnSetFieldValue={handleOnSetFieldValue}
          values={values}
          errors={errors}
          handleOnSubmit={handleOnSubmit}
          handleOnSave={handleOnShowSaveProfileModal}
        />
      );
    case 45:
      return (
        <Report45Options
          handleOnSetFieldValue={handleOnSetFieldValue}
          values={values}
          handleOnSubmit={handleOnSubmit}
          handleOnSave={handleOnShowSaveProfileModal}
          selectedReport={selectedReport}
        />
      );
    case 47:
      return (
        <Report47Options
          handleOnSetFieldValue={handleOnSetFieldValue}
          values={values}
          handleOnSubmit={handleOnSubmit}
          handleOnSave={handleOnShowSaveProfileModal}
          selectedReport={selectedReport}
        />
      );
    case 49:
      return (
        <Report49Options
          handleOnSetFieldValue={handleOnSetFieldValue}
          values={values}
          handleOnSubmit={handleOnSubmit}
          handleOnSave={handleOnShowSaveProfileModal}
        />
      );
    case 50:
      return (
        <Report50Options
          handleOnSetFieldValue={handleOnSetFieldValue}
          values={values}
          handleOnSubmit={handleOnSubmit}
          handleOnSave={handleOnShowSaveProfileModal}
          selectedReport={selectedReport}
        />
      );
    case 51:
      return (
        <Report51Options
          handleOnSetFieldValue={handleOnSetFieldValue}
          values={values}
          handleOnSubmit={handleOnSubmit}
          handleOnSave={handleOnShowSaveProfileModal}
          selectedReport={selectedReport}
        />
      );
    case 52:
      return (
        <Report52Options
          handleOnSetFieldValue={handleOnSetFieldValue}
          values={values}
          handleOnSubmit={handleOnSubmit}
          handleOnSave={handleOnShowSaveProfileModal}
          selectedReport={selectedReport}
        />
      );
    case 53:
      return (
        <Report53Options
          handleOnSetFieldValue={handleOnSetFieldValue}
          values={values}
          handleOnSubmit={handleOnSubmit}
          handleOnSave={handleOnShowSaveProfileModal}
          selectedReport={selectedReport}
        />
      );
    case 54:
      return (
        <Report54Options
          handleOnSetFieldValue={handleOnSetFieldValue}
          values={values}
          handleOnSubmit={handleOnSubmit}
          handleOnSave={handleOnShowSaveProfileModal}
          selectedReport={selectedReport}
        />
      );
    case 56:
      return (
        <Report56Options
          handleOnSetFieldValue={handleOnSetFieldValue}
          values={values}
          handleOnSubmit={handleOnSubmit}
          handleOnSave={handleOnShowSaveProfileModal}
          selectedReport={selectedReport}
        />
      );
    case 57:
      return (
        <Report57Options
          handleOnSetFieldValue={handleOnSetFieldValue}
          values={values}
          handleOnSubmit={handleOnSubmit}
          handleOnSave={handleOnShowSaveProfileModal}
          selectedReport={selectedReport}
        />
      );
    case 59:
      return (
        <Report59Options
          handleOnSetFieldValue={handleOnSetFieldValue}
          values={values}
          handleOnSubmit={handleOnSubmit}
          handleOnSave={handleOnShowSaveProfileModal}
          selectedReport={selectedReport}
        />
      );
    case 60:
      return (
        <Report60Options
          handleOnSetFieldValue={handleOnSetFieldValue}
          values={values}
          handleOnSubmit={handleOnSubmit}
          handleOnSave={handleOnShowSaveProfileModal}
          selectedReport={selectedReport}
        />
      );
    default:
      return (
        <BtnOptions
          isDisabled={
            (!values.plants || values.plants.length === 0) &&
            (!values.plantGroups || values.plantGroups.length === 0)
          }
          handleOnSave={() => handleOnShowSaveProfileModal(true)}
          handleOnSubmit={() => handleOnSubmit()}
        />
      );
  }
};

export default ReportOptionsSwitch;
